export const initialState = {
  count: 0,
  loading: false,
  anchorEl: null,
  unreadCount:3,
  hasNotifications:true,
  openAlert:false,
  notifications: [],
};